import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './pricing8.css'

const Pricing8 = (props) => {
  const [isMonthly, setIsMonthly] = useState(true)
  return (
    <div
      className={`pricing8-thq-pricing23-elm thq-section-padding ${props.rootClassName} `}
    >
      <div className="pricing8-thq-max-width-elm thq-section-max-width">
        <div className="pricing8-thq-section-title-elm">
          <div className="pricing8-thq-content-elm">
            <h2 className="pricing8-thq-text-elm10 thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="pricing8-text16">
                    Download To Activate Free Trial - No Signup Required
                  </span>
                </Fragment>
              )}
            </h2>
          </div>
        </div>
        <div className="pricing8-thq-tabs-elm">
          {isMonthly === true && (
            <button
              onClick={() => setIsMonthly(true)}
              className="pricing8-button1 thq-button-filled thq-button-animated"
            >
              <span className="thq-body-small">Monthly</span>
            </button>
          )}
          {isMonthly === false && (
            <button
              onClick={() => setIsMonthly(true)}
              className="pricing8-button2 thq-button-outline thq-button-animated"
            >
              <span className="thq-body-small">Monthly</span>
            </button>
          )}
          {isMonthly === false && (
            <button
              onClick={() => setIsMonthly(false)}
              className="pricing8-button3 thq-button-filled thq-button-animated"
            >
              <span className="thq-body-small">Yearly</span>
            </button>
          )}
          {isMonthly === true && (
            <button
              onClick={() => setIsMonthly(false)}
              className="pricing8-button4 thq-button-outline thq-button-animated"
            >
              <span className="thq-body-small">Yearly</span>
            </button>
          )}
        </div>
        {isMonthly === true && (
          <div className="pricing8-container">
            <div className="pricing8-thq-column-elm1 thq-card"></div>
            <div className="pricing8-thq-column-elm2 thq-card">
              <svg viewBox="0 0 1024 1024" className="pricing8-icon10">
                <path d="M598 298v-84h-172v84h172zM854 298q34 0 59 26t25 60v128q0 34-25 60t-59 26h-256v-86h-172v86h-256q-36 0-60-25t-24-61v-128q0-34 25-60t59-26h170v-84l86-86h170l86 86v84h172zM426 682h172v-42h298v170q0 36-25 61t-61 25h-596q-36 0-61-25t-25-61v-170h298v42z"></path>
              </svg>
              <div className="pricing8-thq-price-elm1">
                <div className="pricing8-thq-price-elm2">
                  <p className="pricing8-thq-text-elm15 thq-body-large">
                    {props.plan2 ?? (
                      <Fragment>
                        <span className="pricing8-text20">Monthly Plan</span>
                      </Fragment>
                    )}
                  </p>
                  <h3 className="pricing8-thq-text-elm16 thq-heading-3">
                    {props.plan2Price ?? (
                      <Fragment>
                        <span className="pricing8-text11">$11.99/mo</span>
                      </Fragment>
                    )}
                  </h3>
                </div>
                <div className="pricing8-thq-list-elm1">
                  <div className="pricing8-thq-list-item-elm1">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="pricing8-thq-text-elm17 thq-body-small">
                      {props.plan2Feature1 ?? (
                        <Fragment>
                          <span className="pricing8-text18">
                            Deep insight for a low price
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing8-thq-list-item-elm2">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="pricing8-thq-text-elm18 thq-body-small">
                      {props.plan2Feature2 ?? (
                        <Fragment>
                          <span className="pricing8-text10">
                            Know before you move
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing8-thq-list-item-elm3">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="pricing8-thq-text-elm19 thq-body-small">
                      {props.plan2Feature3 ?? (
                        <Fragment>
                          <span className="pricing8-text23">
                            Instant Answers
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing8-thq-list-item-elm4">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="pricing8-thq-text-elm20 thq-body-small">
                      {props.plan2Feature4 ?? (
                        <Fragment>
                          <span className="pricing8-text13">
                            Robust reports - impress clients.
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricing8-thq-column-elm3 thq-card"></div>
          </div>
        )}
        {isMonthly === false && (
          <div className="pricing8-thq-container-elm">
            <div className="pricing8-thq-column-elm4 thq-card"></div>
            <div className="pricing8-thq-column-elm5 thq-card">
              <svg viewBox="0 0 1024 1024" className="pricing8-icon20">
                <path d="M598 298v-84h-172v84h172zM854 298q34 0 59 26t25 60v128q0 34-25 60t-59 26h-256v-86h-172v86h-256q-36 0-60-25t-24-61v-128q0-34 25-60t59-26h170v-84l86-86h170l86 86v84h172zM426 682h172v-42h298v170q0 36-25 61t-61 25h-596q-36 0-61-25t-25-61v-170h298v42z"></path>
              </svg>
              <div className="pricing8-thq-price-elm3">
                <div className="pricing8-thq-price-elm4">
                  <span className="pricing8-thq-text-elm21 thq-body-large">
                    {props.plan21 ?? (
                      <Fragment>
                        <span className="pricing8-text14">Business plan</span>
                      </Fragment>
                    )}
                  </span>
                  <h3 className="pricing8-thq-text-elm22 thq-heading-3">
                    {props.plan2Price1 ?? (
                      <Fragment>
                        <span className="pricing8-text17">$299/year</span>
                      </Fragment>
                    )}
                  </h3>
                  <span className="thq-body-large">
                    {props.plan2Yearly1 ?? (
                      <Fragment>
                        <span className="pricing8-text12">or $29 monthly</span>
                      </Fragment>
                    )}
                  </span>
                </div>
                <div className="pricing8-thq-list-elm2">
                  <div className="pricing8-thq-list-item-elm5">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature11 ?? (
                        <Fragment>
                          <span className="pricing8-text21">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing8-thq-list-item-elm6">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature21 ?? (
                        <Fragment>
                          <span className="pricing8-text19">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing8-thq-list-item-elm7">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature31 ?? (
                        <Fragment>
                          <span className="pricing8-text22">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing8-thq-list-item-elm8">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature41 ?? (
                        <Fragment>
                          <span className="pricing8-text15">
                            Feature text goes here
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricing8-thq-column-elm6 thq-card"></div>
          </div>
        )}
      </div>
    </div>
  )
}

Pricing8.defaultProps = {
  plan2Feature2: undefined,
  plan2Price: undefined,
  plan2Yearly1: undefined,
  plan2Feature4: undefined,
  plan21: undefined,
  plan2Feature41: undefined,
  heading1: undefined,
  plan2Price1: undefined,
  plan2Feature1: undefined,
  rootClassName: '',
  plan2Feature21: undefined,
  plan2: undefined,
  plan2Feature11: undefined,
  plan2Feature31: undefined,
  plan2Feature3: undefined,
}

Pricing8.propTypes = {
  plan2Feature2: PropTypes.element,
  plan2Price: PropTypes.element,
  plan2Yearly1: PropTypes.element,
  plan2Feature4: PropTypes.element,
  plan21: PropTypes.element,
  plan2Feature41: PropTypes.element,
  heading1: PropTypes.element,
  plan2Price1: PropTypes.element,
  plan2Feature1: PropTypes.element,
  rootClassName: PropTypes.string,
  plan2Feature21: PropTypes.element,
  plan2: PropTypes.element,
  plan2Feature11: PropTypes.element,
  plan2Feature31: PropTypes.element,
  plan2Feature3: PropTypes.element,
}

export default Pricing8
